/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-underscore-dangle */
import React from 'react';
import { Button, Spinner } from 'reactstrap';
// import PropTypes from 'prop-types';
import { ReactTitle } from 'react-meta-tags';
// import { setUser } from '../../../redux/actions/userActions';
import { customLogin, redirectMtlsBroker } from '../../../utils/auth';

class LogIn extends React.Component {
  // static propTypes = {
  //   dispatch: PropTypes.func.isRequired,
  // };

  constructor() {
    super();
    this.state = {
      isLoading: false,
      // isRedirecting: false,
      // error: false,
    };
  }

  componentDidMount = () => {
    if (window.location.hash) {
      customLogin(window.location.hash.substring(1));
    }
  }

  loginNotary = (prefix) => {
    // const { dispatch } = this.props;
    const { isLoading } = this.state;
    if (isLoading) return;
    this.setState({ isLoading: true });
    redirectMtlsBroker(prefix);
  }

  render() {
    const { isLoading } = this.state;
    const prefixes = ['real'];
    const testMode = window._env_ ? window._env_.TEST_MODE : process.env.REACT_APP_TEST_MODE;
    if (testMode) {
      prefixes.push('self-signed', 'certinomis');
    }

    return (
      <div className="account d-flex align-items-center justify-content-center">
        <ReactTitle title="FICONUM - Connexion" />
        <div className="p-10">
          <div className="account__head-noBorder text-center">
            <img style={{ width: 200, height: 62 }} src={`${process.env.PUBLIC_URL}/img/logo_white.svg`} alt="logo_img" />
          </div>
          <div className="account__card">
            <div className="account__have-account mt-0">
              <h5 className="fw-500">
                Utilisez le FICONUM pour accéder aux informations patrimoniales et successorales d'un défunt.
              </h5>
              <div className="mt-8">
                <a className="fc-link" href="https://legitbee.com" target="_blank" rel="noopener noreferrer">
                  Qu’est-ce que le FICONUM ?
                </a>
              </div>
            </div>
            <div className="account__or">
              <p>Connexion</p>
            </div>
            <div className="text-center mt-40">
              {
                prefixes.map(prefix => (isLoading ? (
                  <Button key={prefix} onClick={() => this.loginNotary(prefix)} color="official">
                    <Spinner
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  </Button>
                ) : (
                  <Button key={prefix} onClick={() => this.loginNotary(prefix)} color="official">
                    Connectez-vous avec votre clé REAL{prefix !== 'real' ? ` (${prefix})` : ''}
                  </Button>
                )))
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default LogIn;
